import React from "react";

const dataList = [
  { title: "Application", image: "apk.png", fileName: "negi-indane-gas-service.apk" },
  { title: "Printer", image: "printer.png", fileName: "RAWBT_printer.apk" },
];
export default function DownloadComponent() {
  const DownloadHandler = (fileName) => {
    window.location = process.env.REACT_APP_FILE_URL + fileName;
  };
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-2 px-10">
      {dataList.map((item, i) => (
        <div
          onClick={() => DownloadHandler(item.fileName)}
          key={`ITEM_${i}`}
          className="max-w-sm bg-white border border-gray-200 rounded-lg shadow-md cursor-pointer"
        >
          <div>
            <img
              className="rounded-t-lg"
              src={require(`../../../assets/${item.image}`)}
              alt=""
            />
          </div>
          <div className="p-5">
            <div>
              <h6 className="mb-2  font-bold tracking-tight text-gray-900 ">
                {item.title}
              </h6>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
